import { FC } from 'react';
import { LINE_OFFICIAL_URL } from 'constants/externalLinks';

interface Props {
  label?: string;
}

/**
 * 右上角「返回配客嘉 LINE」按鈕。
 *
 * 背景：LINE LIFF 的 × 關閉行為在「使用者從外部瀏覽器跳進來」的情境下
 * 不保證回到 OA chat（即便 Add friend option 設 aggressive 也有可能掉到
 * LINE 預設畫面）。於是給使用者一個明確的按鈕主動回 OA，不依賴 × 的
 * 不確定行為。
 *
 * 用途頁：/nearby、/problem、/discount/ecommerce 等 LIFF 頁。
 */
const BackToOfficialLine: FC<Props> = ({ label = '回配客嘉 LINE' }) => {
  const onClick = () => {
    window.location.href = LINE_OFFICIAL_URL;
  };

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="回配客嘉 LINE"
      style={{
        position: 'fixed',
        top: 'max(12px, calc(12px + env(safe-area-inset-top)))',
        right: 12,
        zIndex: 1000,
        background: '#ffffff',
        color: '#3db270',
        border: '1.5px solid #3db270',
        borderRadius: 18,
        padding: '6px 14px',
        fontSize: 12,
        fontWeight: 700,
        boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
        cursor: 'pointer',
        WebkitTapHighlightColor: 'transparent',
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        lineHeight: 1.2,
      }}
    >
      <span style={{ fontSize: 14, lineHeight: 1 }}>←</span>
      {label}
    </button>
  );
};

export default BackToOfficialLine;
